import { useState } from "react";
import Textarea from "../../../../componentes/input/textarea";
import Button from "../../../../componentes/button/button";
import AcaoButtons from "../../Shared/AcaoButtons";

// Etapa "Confirmação da Multa" — Confirmar / Retornar para reconhecimento / Cancelar.
export default function EtapaMultaConfirmacao({ acoes = [], acaoEmExecucao, onExecutarAcao }) {
    const [observacao, setObservacao] = useState("");

    const podeConfirmar = acoes.includes("CONFIRMAR");
    const outrasAcoes = acoes.filter(a => a !== "CONFIRMAR");

    function executar(acao) {
        onExecutarAcao(acao, { comentario: observacao || undefined });
    }

    return (
        <div className="flex flex-col gap-4">
            <p className="text-sm text-muted-foreground">
                Confirme os dados da multa ou retorne a solicitação para o reconhecimento do condutor.
            </p>

            <Textarea label="Observações" value={observacao} onChange={e => setObservacao(e.target.value)} rows={3} />

            <div className="flex justify-end gap-2 flex-wrap">
                <AcaoButtons acoes={outrasAcoes} acaoEmExecucao={acaoEmExecucao} onAcao={executar} />
                {podeConfirmar && (
                    <Button
                        variant="green"
                        label="Confirmar multa"
                        iconLeft="fa fa-check-circle"
                        loading={acaoEmExecucao === "CONFIRMAR"}
                        onClick={() => executar("CONFIRMAR")}
                    />
                )}
            </div>
        </div>
    );
}
